import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class EditTrendingCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Trending Categories", link: "/trending-categories" },
        { title: "Edit Trending Category", link: "#" },
      ],
      name: "",
      image: null,
      imagePreview: null,
      trendingCategoryId: null,
    };
  }

  componentDidMount() {
    this.loadTrendingCategoryData();
  }

  loadTrendingCategoryData = () => {
    const { trendingCategory } = this.props.router.location.state || {};
    if (trendingCategory) {
      this.setState({
        name: trendingCategory.name || "",
        imagePreview: trendingCategory.image ? `${config.IMAGE_URL}/${trendingCategory.image}` : null,
        trendingCategoryId: trendingCategory._id,
      });
    } else {
      // If no state data, get from URL params
      const id = this.props.router.params.id;
      if (id) {
        this.fetchTrendingCategory(id);
      }
    }
  };

  fetchTrendingCategory = async (id) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/trending-categories/${id}`);
      const data = await response.json();
      if (response.ok) {
        this.setState({
          name: data.name || "",
          imagePreview: data.image ? `${config.IMAGE_URL}/${data.image}` : null,
          trendingCategoryId: data._id,
        });
      }
    } catch (error) {
      console.error('Error fetching trending category:', error);
    }
  };


  handleInputChange = (e) => {
    this.setState({
      name: e.target.value,
    });
  };


  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        image: file,
        imagePreview: URL.createObjectURL(file),
      });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('name', this.state.name);
      
      if (this.state.image) {
        formData.append('image', this.state.image);
      }

      // Debug logs
      console.log('Sending trending category update data:', {
        name: this.state.name,
        image: this.state.image ? this.state.image.name : 'No new image'
      });

      const response = await fetch(`${config.API_BASE_URL}/trending-categories/${this.state.trendingCategoryId}`, {
        method: 'PUT',
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        console.log('Trending category updated:', data);
        this.props.router.navigate("/trending-categories");
      } else {
        console.error('Failed to update trending category:', data);
        alert(data.message || 'Failed to update trending category');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error updating trending category');
    }
  };

  handleCancel = () => {
    this.props.router.navigate("/trending-categories");
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Edit Trending Category"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Name</Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter trending category name"
                              value={this.state.name}
                              onChange={this.handleInputChange}
                              required
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Image</Label>
                            <Input
                              type="file"
                              className="form-control"
                              onChange={this.handleImageChange}
                              accept="image/*"
                            />
                            {this.state.imagePreview && (
                              <img
                                src={this.state.imagePreview}
                                alt="Trending Category Preview"
                                className="img-fluid mt-2"
                                style={{ maxHeight: "200px" }}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col className="d-flex justify-content-end">
                          <Button type="submit" color="primary" className="me-2">
                            Update Trending Category
                          </Button>
                          <Button type="button" color="secondary" onClick={this.handleCancel}>
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(EditTrendingCategory);
